import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

// TODO: Get design input on container horizontal padding value
const containerVariants = cva("mx-auto w-full px-(--spacing-16)", {
  variants: {
    size: {
      sm: "max-w-[600px]",
      md: "max-w-[905px]",
      lg: "max-w-[1240px]",
      xl: "max-w-[1440px]",
      full: "max-w-none",
    },
  },
  defaultVariants: {
    size: "lg",
  },
});

export interface ContainerProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "className"> {
  /** Max-width preset. Defaults to "lg". Matches design system breakpoints:
   * sm=600px, md=905px, lg=1240px, xl=1440px, full=none */
  size?: "sm" | "md" | "lg" | "xl" | "full";
  children?: React.ReactNode;
}

/**
 * Centered, max-width content wrapper for page-level layout.
 *
 * @example
 * <Container size="xl">
 *   <Stack gap={24}>
 *     <Title>Page Title</Title>
 *     {content}
 *   </Stack>
 * </Container>
 */
function Container({ size, children, ...props }: ContainerProps) {
  return (
    <div className={cn(containerVariants({ size }))} {...props}>
      {children}
    </div>
  );
}

export { Container };
